<template>
  <v-expansion-panel-header>
    <v-row class="p-lr-5 gateway-wrapper">
      <v-col cols="12">
        <slot></slot>
      </v-col>
      <v-col cols="6">
        <p>Processing time:</p>
        <p class="bold"><slot name="processing_time"></slot></p>
        <p>Fee:</p>
        <p class="bold"><slot name="fee"></slot></p>
      </v-col>
      <v-col cols="6">
        <p>Min. withdrawal amount:</p>
        <p class="bold">
          <slot name="min_withdrawal"></slot>
        </p>
        <p>Max. withdrawal amount:</p>
        <p class="bold">
          <slot name="max_withdrawal"></slot>
        </p>
      </v-col>
    </v-row>
  </v-expansion-panel-header>
</template>
<script>
export default {
  name: "FormHeader",
}
</script>